import { dateFormat } from '@/helpers/dateFormat';
import { IUnitClient } from '@/interfaces/client';
import { IPrescriptionBase } from '@/interfaces/prescription-base';
import DoctorModel from '@/models/doctor-model';
import PatientModel from '@/models/patient-model';
import PrescriptionModel from '@/models/prescription-model';
import { BaseFiltroPagDTO, IdNomeDTO, JsonException } from './base-dto';
import { UnidadesMedidasProdutosPacienteCalcParm } from './product';

export default interface IPrescription extends IPrescriptionBase {
  idPrescricao: string;
  idPrescricaoCopia: string;
  dataPrescricaoCopia: string;
  idTemplate: string;
  template: any;
  idTranscricao?: string;
  nomeArquivoTranscricao?: string;
  pathArquivoTranscricao?: string;
  idSiPro?: string;
  seqsSiProMultiPrescricao?: string[];
  unidade: IUnitClient;
  terapia: IdNomeDTO;
  medico: DoctorModel;
  registro?: string;
  leito?: any;
  setor?: any;
  same?: any;
  dietaPadrao?: any;
  dataPrescricao: string;
  dataPrescricaoTime?: string;
  dataProducao: Date;
  dataCriacao?: string;
  dataCriacaoTime?: string;
  convenio?: any;
  endereco?: any;
  paciente: PatientModel;
  statusPrescricao: string;
  tipoPrescricao?: string;
  descricaoTipo?: string;
  tipoTranscricao?: string;
  copy: boolean;
  model: boolean;
  profile: boolean;
  pattern: boolean;
  transcriptionCopy?: boolean;
  transcricaoEmProgresso: boolean;
  responsavel?: any;
  permissao: IPrescrPermissaoAlterDTO;
  enteral: EnteralPrescricaoDTO;
  observacao: string;
  observacaoPrescricao: string;
  usoPesoCalorico: boolean;
  validar: boolean;
  msgPodeValidar: string;
}

export interface IPrescrPermissaoAlterDTO {
  usuarioPodeExcluir: boolean;
  usuarioPodeAprovar: boolean;
  usuarioPodeRecusar: boolean;
  usuarioPodeValidar: boolean;
  usuarioLogadoPrescritor: boolean;
  usuarioPodeAgendarProducao: boolean;

  msgPodeValidar: string;
  checkCienteAdiantAprovacao: boolean;
  msgCienteAdiantAprovacao: string;
  msgAgendarProducao: string;
}

export interface IPrescriptionFilter {
  patientId?: number;
  doctorId?: number;
  clientId?: number;
  hospitalUnitId?: number;
  prescriptionDate?: any;
  productionDate?: any;
  prescriptionCreatedDate?: any;
  prescriptionStatus?: string | string[];
  startDate?: string;
  endDate?: string;
  idSipro?: string;
  idPrescription?: string;
  patientTypes?:
    | 'usoPacienteAdulto'
    | 'usoPacientePediatrico'
    | 'usoPacienteNeonato';
  hasPagination?: boolean;
  sortBy?: string;
  descending?: boolean;
  page?: number;
  rowsPerPage?: number;
  clientSelected?: boolean;
  companySelected?: boolean;
}

export class BolsaCompartMinMaxDTO {
  minConfig: number;
  maxConfig: number;
  minPermit: number;
  maxPermit: number;
}

export class BolsaMulticompartPrescricaoDTO {
  idPrescricao: Number;
  idSipro: string;
  idModelo: Number;
  codigoModelo: string;
  nomeModelo: string;
  capacidadeTotal: Number;
  capacidadeTotalFormat: string;
  uso: Number;
  usoFormat: string;
  produtos: ProdutoPrescricaoCompartDTO[];
}

export class ProdutoPrescricaoCompartDTO {
  idProduto: Number;
  codProduto: string;
  nomeProduto: string;
  idCompartimento: Number;
  letraCompart: string;
  quantidade: Number;  
  quantidadeFormat: string;
  agua: boolean;
}

export class BolsaMulticompartException extends JsonException {
  mensagemNaoAtende: string;
  produtosNaoAtende: string[];  
  compartsAjustar: CompartAjustar[];
  mensagemAgua: string;
}

export class CompartAjustar {
  letra:string;
  capacidadeMl: number;
  capacidadeMlFormat: string;
  usado: number;
  usadoFormat: string;
  produtosAjustar: string[];
  mensagem:string;
}

export class EnteralPrescricaoDTO {
  idEnteral: Number;
  nomeEnteral: string;
  quantidadeEnteral: Number;
}

export class EnteralPrescricaoListDTO {
  enterais: IdNomeDTO[];
  objetivoCalorico: number;
  fatorTermogenese: number;
  fatorSuspensao: number;
  permiteAlterarConfigs: boolean;
  tipoCalculo: IdNomeDTO;
}

export class InsumoObrigatorioException extends JsonException {
  titulo: string;
  codInsumo: string;
  mensagem: string;
  explicacao: string;
}

export class PrescricaoResumoParmDTO extends UnidadesMedidasProdutosPacienteCalcParm {  
  idMedico:Number;  
  divisaoBolsas: number;

  public load(model: PrescriptionModel) {
    super.load(model);
    this.idMedico = model.medico && model.medico.id ? Number(model.medico.id) : null;
    this.divisaoBolsas = model.divisaoBolsas;
  }
}

export class PrescricaoParmDTO extends PrescricaoResumoParmDTO {
  idPrescricaoCopia: number;
  idNotificacaoOrigem: number;
  origemLink: string;
  tipoPrescricao: string;
  same: string;
  leito: string;
  viaAdministracao: string;
  registro: string;
  idSetor: number;
  idTemplate: number;
  idConvenio: number;
  idEndereco: number;
  bolsaMulticompart: boolean;
  quantidadePrescricoes: number;
  justifQuantidade: string;
  observacaoPrescricao: string;
  datasPrescricao: string[];
  idTerapia: number;
  diasTN: string;
  idEnteral: number;
  quantidadeEnteral: number;
  codInsumosCienteObrig: string[];
  idsPrescrAlter: number[];
  uuid: string;  

  public load(model: PrescriptionModel){
    super.load(model);
    this.idPrescricaoCopia = model.idPrescricaoCopia? Number(model.idPrescricaoCopia) : null;
    this.tipoPrescricao = model.tipoPrescricao;
    if (model.paciente) {
      this.same = model.paciente.same;
    }
    this.leito = model.leito;
    this.viaAdministracao = model.viaAdministracao;
    this.registro = model.registro;
    this.idSetor = model.setor && model.setor.id ? Number(model.setor.id) : null;
    this.idTemplate = model.idTemplate ? Number(model.idTemplate) : null;
    this.idConvenio = model.convenio && model.convenio.id ? Number(model.convenio.id) : null;
    this.idEndereco = model.endereco && model.endereco.id ? Number(model.endereco.id) : null;
    this.bolsaMulticompart = model.bolsaMulticompart;
    this.quantidadePrescricoes = model.quantidade;
    this.justifQuantidade = model.justifQuantidade;
    this.observacaoPrescricao = model.observacaoPrescricao;
    this.datasPrescricao = model.dataPrescricao.map(d => {
      return dateFormat(d, 'ISO', 'YYYY-MM-DD');
    });
    this.idTerapia = model.terapia && model.terapia.id ? Number(model.terapia.id) : null;
    this.diasTN = model.tnDays;
    if (model.enteral && model.enteral.idEnteral){
      this.idEnteral = Number(model.enteral.idEnteral);
      this.quantidadeEnteral = model.enteral.quantidadeEnteral.valueOf();
    }
    this.codInsumosCienteObrig = model.codInsumosCienteObrig;
  }
}

export class PrescricaoAlterParmDTO extends PrescricaoParmDTO {
  idAlteracao: number;
  idValorParmMotivo: number;
}

export class TranscricaoParmDTO extends PrescricaoParmDTO {
  tipoTranscricao: string;
  idTranscricao: number;
  ocrKey: string;

  public load(model: PrescriptionModel){
    super.load(model);
    this.tipoTranscricao = model.tipoTranscricao;
    this.idTranscricao = model.idTranscricao ? Number(model.idTranscricao) : null;
  }
}

export class PrescricaoFiltroParmDTO extends BaseFiltroPagDTO {
  idUnidade: number;
  idMedico: number;
  idPaciente: number;
  idSiPro: string;
  dataProducaoRealizada: boolean;
  dataProducaoInicio: string;
  dataProducaoFim: string;
  dataEntregaRealizada: boolean;
  dataEntregaInicio: string;
  dataEntregaFim: string;
  dataCriacaoInicio: string;
  dataCriacaoFim: string;
  bolsaMulti: boolean;
  statuses: string[];
}

export class AlterDadosBasicPrescrParmDTO {
  idPrescricao: number;
  registro: string;
}

export class PrescriptionDraftItemList {
  id: string;
  nmUnidade: string
  nmCliente: string
  nmPaciente: string;
  dataCriacaoFmt: string;
  qtdeProdutos: number;
}

export class AprovacaoAgendadaMultiParteParmDTO {
  quantidade: number;
  data: string;
  hora: string;
}

export class AprovacaoAgendadaMultiParmDTO {
  idPrescricao: number;
  partes: Array<AprovacaoAgendadaMultiParteParmDTO> = new Array();
}

export class PrescricaoOpcoesProdutosParmDTO {
  idUnidade: number;
  tipoPaciente: string;
  idPaciente: number;
  peso: number;
  template: boolean;
}